import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import MyFacilitiesList from "./myFacilities/myFacilitiesList";
import ProvidersList from "./providers/providersList";
import AllPendingCmns from "./cmns/allPendingCmns";
import DispatchList from "./dispatch/dispatchList";
import ExceptionsList from "./exceptions/exceptionsList";

export function CmnQueueMain() {
  const [cmnEnabled, setCmnEnabled] = useState(false);
  const [cmnAdvancedEnabled, setCmnAdvancedEnabled] = useState(false);
  const [featureChecked, setFeatureChecked] = useState(false);
  const CMN_CORE_FEATURE_TASK_ID = 7;
  const CMN_ADVANCED_FEATURE_TASK_ID = 8;

  useEffect(() => {
    Promise.all([
      Api.getRequest(Api.URI_FeatureSwitch + CMN_CORE_FEATURE_TASK_ID),
      Api.getRequest(Api.URI_FeatureSwitch + CMN_ADVANCED_FEATURE_TASK_ID),
    ])
      .then(([coreRes, advancedRes]) => {
        setCmnEnabled(coreRes?.data?.result === true);
        setCmnAdvancedEnabled(advancedRes?.data?.result === true);
      })
      .catch(() => {
        setCmnEnabled(false);
        setCmnAdvancedEnabled(false);
      })
      .finally(() => {
        setFeatureChecked(true);
      });
  }, []);

  if (!featureChecked) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <span className="spinner spinner-primary"></span>
      </div>
    );
  }

  if (!cmnEnabled) {
    return (
      <div className="alert alert-warning m-5" role="alert">
        <strong>CMN Queue is currently disabled.</strong> Please contact your administrator to enable this feature.
      </div>
    );
  }

  return (
    <>
      <Tabs defaultActiveKey="myFacilities" id="cmn-queue-main-tabs" className="mb-3">
        <Tab eventKey="myFacilities" title="My Facilities">
          <MyFacilitiesList />
        </Tab>
        {cmnAdvancedEnabled && (
          <Tab eventKey="providers" title="Providers">
            <ProvidersList />
          </Tab>
        )}
        {cmnAdvancedEnabled && (
          <Tab eventKey="cmns" title="CMNs">
            <AllPendingCmns />
          </Tab>
        )}
        {cmnAdvancedEnabled && (
          <Tab eventKey="dispatch" title="Dispatch">
            <DispatchList />
          </Tab>
        )}
        {cmnAdvancedEnabled && (
          <Tab eventKey="exceptions" title="Exceptions">
            <ExceptionsList />
          </Tab>
        )}
      </Tabs>
    </>
  );
}

export default CmnQueueMain;
